<template>
    <div v-if="skeletonName" class="skeleton-wrapper">
        <component :is="skeletonName"></component>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import allTop from './allTop';
import bless_sort from './bless_sort';
import classify_singer from './classify_singer';
import home from './home';
import loading from './loading';
import mv from './mv';
import photo from './photo';
import photov2 from './photov2';

export default {
  computed: {
    ...mapState({
      skeletonName: (state) => state.skeletonName,
    }),
  },
  components: {
    allTop,
    bless_sort,
    classify_singer,
    home,
    loading,
    mv,
    photo,
    photov2,
  },
};
</script>
